

















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import RangeSlider from "@/components/VRangeSliderStyling.vue";

import ColorPicker from '@/commonComponents/colorPicker/colorPicker.vue';

import * as def from '@/definitions'

import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { ColorConstruct } from '@/utilityModels/colorConstruct';
import { ImageLayer } from '@/model/document2/page/surface/design/layer/imageLayer';
import { MathHelper } from '@/helper/mathHelper';

import ColorSelector from "@/commonComponents/colorSelector/colorSelector.vue";
import AdjustedBalloon from '@/commonComponents/adjustedBalloon/adjustedBalloon.vue';

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";
import CheckBoxOn from "../resources/checkBoxOn.vue";

import { ResourceHelper } from "@/helper/resourceHelper"

@Component({
  components: {
      RangeSlider,
      ColorPicker,
      ColorSelector,
      AdjustedBalloon,

      ArrowDown,
      ArrowRight,
      CheckBoxOn
  },
})

export default class ImageShadow extends Vue {

    @Prop() private layer! : ImageLayer;

    //↓↓↓↓↓開閉のアニメーション↓↓↓↓↓
    //こいつはpropsでもらいたい
    openStatus = {
        opend : true
    };

    imageShadowContentsOpenAnimate = false;
    imageShadowContentsCloseAnimate = false;

    open(){
        if(this.openStatus.opend){
            this.imageShadowContentsCloseAnimate = true;
            setTimeout(()=>{this.imageShadowContentsCloseAnimate = false; this.imageShadowContentsOpenAnimate = false; this.openStatus.opend = false;}, 200);
        }else{
            this.openStatus.opend = true;
            this.imageShadowContentsOpenAnimate = true;
            setTimeout(()=>{this.imageShadowContentsOpenAnimate = false;}, 250);
        }
    };
    //↑↑↑↑↑開閉のアニメーション↑↑↑↑↑

    // 影ON/OFF
    private get isShadow() { return this.layer.isShadow; }
    private shadowChange()
    {
        this.changeLayerProperty("isShadow", !this.layer.isShadow, true, true);
    }

    // 影色
    private get shadowColor() : ColorConstruct
    {
        return this.layer.shadowColor;
    }

    private get shadowColorStyle()
    {
        return {
            background : this.shadowColor.hex
        };
    }

    private isShadowColorPickerVisible = false
    private showShadowColorPicker()
    {
        this.isShadowColorPickerVisible = true;
    }
    private closeShadowColorPicker()
    {
        this.isShadowColorPickerVisible = false;
    }

    private onChangingShadowColor(color, tag)
    {
        this.changeLayerProperty(tag, color, false);
    }

    private onChangedShadowColor(color, tag)
    {
        this.changeLayerProperty(tag, color, true);
    }

    // 距離
    private get shadowDistance() { return this.layer.shadowDistance;}
    private get shadowDistanceDisplay() { return MathHelper.roundByDigits(this.shadowDistance, 2).toFixed(2); }

    private set shadowDistance(shadowDistance)
    {
        this.changeLayerProperty("shadowDistance", shadowDistance, false);
    }

    private onChangeShadowDistance(shadowDistance)
    {
        this.changeLayerProperty("shadowDistance", shadowDistance, true);
    }

    // 角度
    private get shadowRotate() { return this.layer.shadowRotate; }
    private get shadowRotateDisplay() { return MathHelper.roundByDigits(this.shadowRotate).toFixed(); }

    private set shadowRotate(shadowRotate)
    {
        this.changeLayerProperty("shadowRotate", shadowRotate, false);
    }

    private onChangeShadowRotate(shadowRotate)
    {
        this.changeLayerProperty("shadowRotate", shadowRotate, true);
    }

    // ぼかし
    private get shadowBlur() { return this.layer.shadowBlur; }
    private get shadowBlurDisplay() { return MathHelper.roundByDigits(this.shadowBlur, 1).toFixed(); }

    private set shadowBlur(shadowBlur)
    {
        this.changeLayerProperty("shadowBlur", shadowBlur, false);
    }

    private onChangeShadowBlur(shadowBlur)
    {
        this.changeLayerProperty("shadowBlur", shadowBlur, true);
    }

    // 強さ
    private get shadowIntensity() { return this.layer.shadowIntensity; }
    private get shadowIntensityDisplay() { return MathHelper.roundByDigits(this.shadowIntensity).toFixed(); }

    private set shadowIntensity(shadowIntensity)
    {
        this.changeLayerProperty("shadowIntensity", shadowIntensity, false);
    }

    private onChangeShadowIntensity(shadowIntensity)
    {
        this.changeLayerProperty("shadowIntensity", shadowIntensity, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean = false)
    {
        this.$emit("doCommand", "changeLayerProperty", { layer : this.layer, propertyName : propertyName, value : value, isFinish: isFinish, isOnce : isOnce });
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style;
    }

    getResource(file : string){
        return ResourceHelper.getResource(file);
    }
}

